import { render, staticRenderFns } from "./PokemonDisplay.vue?vue&type=template&id=317b6fa8&scoped=true"
import script from "./PokemonDisplay.vue?vue&type=script&lang=js"
export * from "./PokemonDisplay.vue?vue&type=script&lang=js"
import style0 from "./PokemonDisplay.vue?vue&type=style&index=0&id=317b6fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b6fa8",
  null
  
)

export default component.exports